import { render, staticRenderFns } from "./custom-pattern.vue?vue&type=template&id=19012d6b&"
import script from "./custom-pattern.vue?vue&type=script&lang=js&"
export * from "./custom-pattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports